import { Component } from "solid-js";
import DefaultAcordeon from "./DefaultAcordeon";
import Styles from "bundle-text:../styles/_addExternalEmail.scss";

interface AddExternalEmailProps {
  onInput: (email: string) => void;
}

const AddExternalEmail: Component<AddExternalEmailProps> = (props) => {
  return (
    <>
      <style>{Styles}</style>
      <DefaultAcordeon
        title="Add an email address not listed or an external email"
        isOpen={true}
      >
        <div class="add-external-email">
          <label>
            Type in your email below<span>*</span>
          </label>
          <input
            type="text"
            placeholder="Enter your external domain@domain.com"
            onInput={(e) => props.onInput(e.currentTarget.value)}
          />
          <span>* Required</span>
        </div>
      </DefaultAcordeon>
    </>
  );
};

export default AddExternalEmail;
